import Vue from 'vue';
import axios from 'axios';
import {hasPermission} from "../../utils/permissions";

// Initial state
const state = {
  brochures: [],
  brochure: {},
  totalPages: 0,
  action: '', // Added to resolve undefined state property issue
};

// Getters
const getters = {
  brochure: (state) => state.brochure,
  brochures: (state) => state.brochures,
  totalPages: (state) => state.totalPages,
};

// Mutations
const mutations = {
  SET_BROCHURE(state, brochure) {
    state.brochure = brochure;
  },

  SET_BROCHURES(state, brochures) {
    state.brochures = brochures;
  },

  SET_ACTION(state, action) {
    state.action = action;
  },

  SET_TOTAL_PAGES(state, totalPages) {
    state.totalPages = totalPages;
  },
};

// Actions
const actions = {
  async getAllbrochures({ commit }, [page, search]) {
    if(hasPermission('brochure')){
      const permission = {
        headers: {
          'X-Permission': 'brochure',
        },
      };
      const productId = localStorage.getItem('product');
      try {
        const response = await axios.get(
            `/admin/brochure?page=${page}&product_id=${productId}&search=${search}`,
            permission
        );
        const res = response.data;
        const totalPages = Math.ceil(res.total / res.per_page);
        commit('SET_TOTAL_PAGES', totalPages);
        commit('SET_BROCHURES', res.data);
      } catch (error) {
        commit('SET_BROCHURES', []);
      }
    }
  },

  async create({}, post) {

    const formData = new FormData();
    formData.append('slug', post.new_slug);
    formData.append('title', post.title);
    formData.append('body', post.body);
    formData.append('caption', post.caption);
    formData.append('meta_title', post.meta_title || '');
    formData.append('meta_description', post.meta_description || '');
    formData.append('meta_keyword', post.meta_keyword || '');
    formData.append('show_in_admin', post.show_in_admin ? 1 : 0);
    formData.append('featured', post.featured ? 1 : 0);
    formData.append('send_email', post.send_email ? 1 : 0);
    formData.append('remove_image', post.remove_image ? 1 : 0);
    formData.append('short_description', post.short_description  || '');
    if(hasPermission('brochure')){
      const permission = {
        headers: {
          'X-Permission': 'brochure',
        },
      };

      try {
        const response = await axios.post(
            `/admin/brochure/create?product_id=${localStorage.getItem('product')}`,
            formData,
            permission
        );
        return response.data;
      } catch (error) {
        console.error('Error creating brochure:', error);
      }
    }
  },

  async update({}, post) {
    const formData = new FormData();
    formData.append('_method', 'PUT');
    formData.append('id', post.id);
    formData.append('slug', post.new_slug);
    formData.append('title', post.title);
    formData.append('body', post.body);
    formData.append('meta_title', post.meta_title || '');
    formData.append('meta_description', post.meta_description || '');
    formData.append('meta_keyword', post.meta_keyword || '');
    formData.append('short_description', post.short_description || '');
    formData.append('show_in_admin', post.show_in_admin ? 1 : 0);
    formData.append('featured', post.featured ? 1 : 0);
    formData.append('send_email', post.send_email ? 1 : 0);
    formData.append('remove_image', post.remove_image ? 1 : 0);
    if (post.caption !== undefined) {
      formData.append('caption', post.caption);
    }

    if(hasPermission('brochure')){
      const permission = {
        headers: {
          'X-Permission': 'brochure',
        },
      };

      try {
        const response = await axios.post(
            `/admin/brochure/update/${post.slug}?product_id=${localStorage.getItem('product')}`,
            formData,
            permission
        );
        return response.data;
      } catch (error) {
        console.error('Error updating brochure:', error);
      }
    }
  },

  async view({ commit }, slug) {
    const permission = {
      headers: {
        'X-Permission': 'brochure',
      },
    };
    const productId = localStorage.getItem('product');
    try {
      const response = await axios.get(`/admin/brochure/${slug}/${productId}`, permission); 
      commit('SET_BROCHURE', response.data.data);
    } catch (error) {
      console.error('Error fetching brochure:', error);
    }
  },

  async delete({}, brochure) {
    const productId = localStorage.getItem('product');
    try {
      const response = await axios.post(`/admin/brochure/delete/${brochure.slug}/${productId}`, {
        '_method': 'DELETE',
      });
      return response.data;
    } catch (error) {
      console.error('Error deleting brochure:', error);
    }
  },

  async publishing({ commit }, payload) {
    const productId = localStorage.getItem('product');
    try {
      const response = await axios.post(
        `/admin/brochure/publish/${payload.brochure.slug}/${payload.action}?product_id=${productId}`
      );
      switch (payload.action) {
        case 'publish':
          payload.brochure.published = 1;
          payload.brochure.published_at = 'Just now';
          break;
        case 'unpublish':
          payload.brochure.published = 0;
          payload.brochure.published_at = '';
          break;
      }
      commit('SET_BROCHURE', payload.brochure);
      return response;
    } catch (error) {
      console.error('Error publishing brochure:', error);
    }
  },
};

// Exporting the Vuex module
export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
